import React from 'react';

interface ProductCardProps {
    icon: string;
    title: string;
    description: string;
}

const ProductCard: React.FC<ProductCardProps> = ({ icon, title, description }) => {
    return (
        <div className="product-card">
            <div className="product-img">
                <span className="material-icons">{icon}</span>
            </div>
            <div className="product-info">
                <h3>{title}</h3>
                <p>{description}</p>
            </div>
        </div>
    );
};

export default ProductCard;